
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div>
Needed something to start with.
      <p>{`Working with NetlifyCMS! ❤️❤️❤️`}</p>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;